import { createRoot } from "react-dom/client";
import { init } from "@sentry/react";
import { SENTRY_DSN, VERSION } from "./settings";

import { App } from "./App";

if (SENTRY_DSN) {
  init({
    dsn: SENTRY_DSN,
    release: VERSION,
  });
}

const root = createRoot(document.getElementById("react-root")!);
root.render(<App />);
